import { Environment, getInventoryBaseUrl } from '../../config/env-config';

const inventory = (env: Environment) => {
  const inventoryBaseUrl = getInventoryBaseUrl(env);

  return {
    get_services: {
      scope: 'platform.services:list',
      url: `${inventoryBaseUrl}/services`,
    },
    get_tenants: {
      scope: 'platform.tenants:list',
      url: (pagenumber = 1, pagesize = 20) => {
        return `${inventoryBaseUrl}/tenants/list?pagenumber=${pagenumber}&pagesize=${pagesize}`;
      },
    },
  };
};

const inventoryApi = {
  get_services: {
    scope: 'platform.services:list',
    url: '/services',
  },
  get_tenants: {
    scope: 'platform.tenants:list',
    url: '/tenants/list',
  },
};

export { inventory, inventoryApi };
